import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS } from 'src/models/ModalModel';
import { MODALS_SIZE } from 'src/models/modal';
import ChooseOrganisationForm from 'src/components/Elements/ChooseOrganisationForm';

const ChooseOrganisationModal = () => (
  <ModalBase
    name={MODALS.chooseOrganisation}
    size={MODALS_SIZE.small}>
    <ChooseOrganisationForm />
  </ModalBase>
);

export default ChooseOrganisationModal;
